const facets = {
  "facets.Womens Underwear": {
    type: "boolean"
  },
  "facets.Caps": {
    type: "boolean"
  },
  "facets.Run Belts": {
    type: "boolean"
  },
  "facets.Backpacks": {
    type: "boolean"
  },
  "facets.Drinkware": {
    type: "boolean"
  },
  "facets.Maternity Bike Shorts": {
    type: "boolean"
  },
  "facets.Maternity Bras": {
    type: "boolean"
  },
  "facets.Maternity Leggings": {
    type: "boolean"
  },
  "facets.Hoodies": {
    type: "boolean"
  },
  "facets.Pullovers": {
    type: "boolean"
  },
  "facets.Jackets": {
    type: "boolean"
  },
  "facets.Long Sleeve Tees": {
    type: "boolean"
  },
  "facets.On_b2b_main": {
    type: "boolean"
  },
  "facets.On_b2b_mode2": {
    type: "boolean"
  },
  "discounted": {
    type: "boolean"
  },
  "available": {
    type: "boolean"
  },
  "facets.Scrunch": {
    type: "boolean"
  },
  "facets.Non-scrunch": {
    type: "boolean"
  },
  "facets.Maternity": {
    type: "boolean"
  },
  "facets.Caffeine Free": {
    type: "boolean"
  },
  "facets.Browse_all": {
    type: "boolean"
  },
  "facets.Womens" : {
    type: "boolean"
  },
  "facets.Mens" : {
    type: "boolean"
  },
  "facets.Leggings": {
    type: "boolean"
  },
  "facets.Shorts": {
    type: "boolean"
  },
  "facets.Mens_shorts": {
    type: "boolean"
  },
  "facets.Bras": {
    type: "boolean"
  },
  "facets.Bralettes": {
    type: "boolean"
  },
  "facets.Tops": {
    type: "boolean"
  },
  "facets.Graphic_tees": {
    type: "boolean"
  },
  "facets.Tees": {
    type: "boolean"
  },
  "facets.Tees_tanks": {
    type: "boolean"
  },
  "facets.Tanks": {
    type: "boolean"
  },
  "facets.Womens_staples": {
    type: "boolean"
  },
  "facets.Mens_staples": {
    type: "boolean"
  },
  "facets.Accessories": {
    type: "boolean"
  },
  "facets.Womens_accessories": {
    type: "boolean"
  },
  "facets.Mens_accessories": {
    type: "boolean"
  },
  "facets.Protein": {
    type: "boolean"
  },
  "facets.Pre_workout": {
    type: "boolean"
  },
  "facets.Bars_snacks": {
    type: "boolean"
  },
  "facets.Custard": {
    type: "boolean"
  },
  "facets.Jumpers": {
    type: "boolean"
  },
  "facets.Tracksuit_sets": {
    type: "boolean"
  },
  "facets.Protein_snacks": {
    type: "boolean"
  },
  "facets.Protein_bars": {
    type: "boolean"
  },
  "facets.Sample_packs": {
    type: "boolean"
  },
  "facets.Daily_greens": {
    type: "boolean"
  },
  "facets.Rtd": {
    type: "boolean"
  },
  "facets.Protein_water": {
    type: "boolean"
  },
  "facets.Winter": {
    type: "boolean"
  },
  "facets.Protein_powder": {
    type: "boolean"
  },
  "facets.Hydration": {
    type: "boolean"
  },
  "facets.Vegan_friendly": {
    type: "boolean"
  },
  "facets.Gluten_free": {
    type: "boolean"
  },
  "facets.Pockets": {
    type: "boolean"
  },
  "facets.Goal": {
    type: "boolean"
  }
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.isInitializing = true; // Flag to prevent submissions during initialization
    this.isSyncing = false; // Flag to prevent syncing loops

    const facetForm = this.querySelector('form');
    if (!facetForm) {
      // Form not ready yet - this can happen during AJAX re-renders
      // Will be initialized on next render
      return;
    }

    this.initializeFormListeners(facetForm);
  }

  initializeFormListeners(facetForm) {
    // Initialize category pill click handlers
    this.initCategoryPills();

    // Initialize sort select dropdowns with direct listeners
    this.initSortSelectListeners(facetForm);

    // CRITICAL FIX: Prevent clicks in hidden tabs from triggering checkboxes/inputs
    // This must be done at capture phase before any processing happens
    facetForm.addEventListener('click', (event) => {
      const collectionTabs = document.querySelector('.collection-tabs');
      if (collectionTabs) {
        // Check if the click target is within a tab-content
        const clickedTab = event.target.closest('.tab-content');
        const visibleTab = collectionTabs.querySelector('.tab-content.visible');

        // If clicking within a hidden tab, prevent it completely
        if (clickedTab && visibleTab && clickedTab !== visibleTab && !clickedTab.classList.contains('visible')) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          return false;
        }
      }
    }, true); // Use capture phase to catch it early

    // Simple handler for single-select deselection
    facetForm.addEventListener('click', (event) => {
      // Handle direct checkbox clicks
      if (event.target.type === 'checkbox' && event.target.hasAttribute('data-single-select') && event.target.checked) {
        // Checkbox is currently checked, this click will uncheck it (browser default behavior)
        // Just let it happen naturally
        return;
      }

      // Handle label clicks
      const label = event.target.closest('label');
      if (label) {
        const checkbox = label.querySelector('input[type="checkbox"][data-single-select="true"]');
        if (checkbox && checkbox.checked) {
          // Clicking label of already-checked single-select checkbox - manually toggle it off
          event.preventDefault();
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // Also block at change event level for checkboxes specifically
    facetForm.addEventListener('change', (event) => {
      if (event.target.type === 'checkbox') {
        const collectionTabs = document.querySelector('.collection-tabs');
        if (collectionTabs) {
          const checkboxTab = event.target.closest('.tab-content');
          const visibleTab = collectionTabs.querySelector('.tab-content.visible');

          // If checkbox change is in hidden tab, block it
          if (checkboxTab && visibleTab && checkboxTab !== visibleTab && !checkboxTab.classList.contains('visible')) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            return false;
          }
        }
      }
    }, true); // Use capture phase

    // Handle checkbox changes immediately without debounce
    facetForm.addEventListener('change', (event) => {
      if (this.isInitializing) return;

      // Skip if we're currently syncing to prevent loops
      if (this.isSyncing) return;

      // Handle checkboxes immediately
      if (event.target && event.target.type === 'checkbox') {
        // Don't let the onchange attribute fire the input event for checkboxes
        event.stopPropagation();

        // SINGLE-SELECT: For colour filter checkboxes, deselect all other colours first
        // This must happen BEFORE onSubmitHandler so only one colour is in the submitted form
        if (event.target.classList.contains('color-filter-checkbox') ||
            event.target.hasAttribute('data-color-filter')) {
          this.handleSingleColorSelection(event);
        }

        this.onSubmitHandler(event);
        return;
      }

      // Handle sort dropdowns immediately
      if (event.target && event.target.matches('select[name="sort_by"]')) {
        this.onSubmitHandler(event);
        return;
      }
    });

    // Handle other input types immediately (like price range inputs)
    facetForm.addEventListener('input', (event) => {
      if (this.isInitializing) return;

      // Skip if we're currently syncing to prevent loops
      if (this.isSyncing) return;

      // Skip checkboxes - they're handled by change event above
      if (event.target && event.target.type === 'checkbox') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();
        return;
      }

      // Skip price range inputs AND sliders - they're handled by change/blur events
      if (event.target && (
          event.target.name === 'filter.v.price.gte' ||
          event.target.name === 'filter.v.price.lte' ||
          event.target.type === 'range' ||
          event.target.classList.contains('price-range-slider')
        )) {
        event.stopImmediatePropagation();
        return;
      }

      // Handle other inputs immediately (no debounce)
      this.onSubmitHandler(event);
    });

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);

    // Always initialize all tabs (including hidden ones) so they're ready when visible
    // Ensure refinementMenu open state matches Details state on load
    FacetFiltersForm.wireRefinementMenus();
    FacetFiltersForm.wireMobileRefinementMenus();

    // For collection tabs, only run cleanup on visible tabs to avoid interference
    const tabContent = this.closest('.tab-content');
    const isInVisibleTab = !tabContent || tabContent.classList.contains('visible');

    if (isInVisibleTab) {
      // Defensive cleanup of any stray boolean options
      FacetFiltersForm.removeBooleanOptions();
      // Remove duplicate groups with the same handle (e.g., two "Collection" groups)
      FacetFiltersForm.dedupeFilterGroups();
    }

    // Add mobile facets header close functionality
    FacetFiltersForm.addMobileFacetsCloseHandler();

    // Add mobile color filter single selection handler
    this.addMobileColorSelectionHandler();

    // Initialize dynamic width for sort select elements
    this.initDynamicSelectWidth();

    // Ensure initial checked states match URL parameters on page load - only if there are URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const hasFilterParams = Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
    if (hasFilterParams) {
      // Skip change events on initial load to prevent clearing color filters
      FacetFiltersForm.syncCheckedStatesWithURL(true);
    }

    // Initialize price range sliders
    this.initPriceRangeSliders();

    // Open filter sections that have active values
    FacetFiltersForm.openActiveFilters();

    // Update category pills active state on initial page load
    FacetFiltersForm.updateCategoryPillsActiveState();

    // Mark initialization as complete
    this.isInitializing = false;
  }

  // Initialize sort select dropdowns with direct change listeners
  initSortSelectListeners(facetForm) {
    // Find sort selects within THIS element so each facet-filters-form
    // initializes its own selects (not just the visible tab's selects)
    let sortSelects = this.querySelectorAll('select[id^="CollectionSortBy"], select[name="sort_by"]');

    // Fallback: try the facetForm
    if (sortSelects.length === 0) {
      sortSelects = facetForm.querySelectorAll('select[id^="CollectionSortBy"], select[name="sort_by"]');
    }

    sortSelects.forEach(select => {
      // Remove any existing listener first to prevent duplicates
      if (select.dataset.sortListenerInitialized === 'true') {
        return;
      }

      // Mark as initialized for sort listener
      select.dataset.sortListenerInitialized = 'true';

      // Also mark as width initialized to prevent duplicate width listeners
      select.dataset.widthInitialized = 'true';

      // Set initial width
      FacetFiltersForm.adjustSelectWidth(select);

      const handleSortChange = (e) => {
        if (this.isInitializing) return;

        // Prevent the default form submission
        e.preventDefault();
        e.stopPropagation();

        const selectedValue = select.value;

        // SCOPED SYNC: Only sync sort selects within the current tab scope (not across all tabs)
        const collectionTabs = document.querySelector('.collection-tabs');
        let syncScope = document;

        if (collectionTabs) {
          // Find which tab this select belongs to
          const selectTab = select.closest('.tab-content');
          if (selectTab) {
            // Only sync within this specific tab
            syncScope = selectTab;
          }
        }

        // Sync the value only with sort selects in the same scope
        const scopedSortSelects = syncScope.querySelectorAll('select[name="sort_by"], select[id^="CollectionSortBy"]');
        scopedSortSelects.forEach(sortSelect => {
          if (sortSelect !== select && sortSelect.value !== selectedValue) {
            sortSelect.value = selectedValue;
            // Also adjust width for other selects if needed
            FacetFiltersForm.adjustSelectWidth(sortSelect);
          }
        });

        // Adjust width after selection changes
        FacetFiltersForm.adjustSelectWidth(select);

        // Trigger the form submission handler
        this.onSubmitHandler(e);
      };

      select.addEventListener('change', handleSortChange);
    });

    // If still no selects found, use MutationObserver to watch for when they're added
    if (sortSelects.length === 0) {
      const observer = new MutationObserver((mutations, obs) => {
        const newSelects = this.querySelectorAll('select[id^="CollectionSortBy"]:not([data-sort-listener-initialized]), select[name="sort_by"]:not([data-sort-listener-initialized])');
        if (newSelects.length > 0) {
          newSelects.forEach(select => {
            select.dataset.sortListenerInitialized = 'true';
            select.dataset.widthInitialized = 'true';

            // Set initial width
            FacetFiltersForm.adjustSelectWidth(select);

            const handleSortChange = (e) => {
              if (this.isInitializing) return;
              e.preventDefault();
              e.stopPropagation();

              const selectedValue = select.value;

              // SCOPED SYNC: Only sync sort selects within the current tab scope (not across all tabs)
              const collectionTabs = document.querySelector('.collection-tabs');
              let syncScope = document;

              if (collectionTabs) {
                // Find which tab this select belongs to
                const selectTab = select.closest('.tab-content');
                if (selectTab) {
                  // Only sync within this specific tab
                  syncScope = selectTab;
                }
              }

              // Sync the value only with sort selects in the same scope
              const scopedSortSelects = syncScope.querySelectorAll('select[name="sort_by"], select[id^="CollectionSortBy"]');
              scopedSortSelects.forEach(sortSelect => {
                if (sortSelect !== select && sortSelect.value !== selectedValue) {
                  sortSelect.value = selectedValue;
                  // Also adjust width for other selects if needed
                  FacetFiltersForm.adjustSelectWidth(sortSelect);
                }
              });

              // Adjust width after selection changes
              FacetFiltersForm.adjustSelectWidth(select);

              this.onSubmitHandler(e);
            };

            select.addEventListener('change', handleSortChange.bind(this));
          });
          obs.disconnect(); // Stop observing once we've found and initialized the selects
        }
      });

      // Observe within the scope root, not the entire document
      const observeTarget = this;
      observer.observe(observeTarget, { childList: true, subtree: true });

      // Disconnect after 3 seconds to avoid infinite observation
      setTimeout(() => observer.disconnect(), 3000);
    }
  }

  // Initialize category pill click handlers
  initCategoryPills() {
    // Scope to current tab if in collection tabs
    const root = FacetFiltersForm.getScopeRoot();
    const categoryPills = root.querySelectorAll('.category-pill');

    categoryPills.forEach(pill => {
      // Remove any existing listener first to prevent duplicates
      if (pill.dataset.categoryPillInitialized === 'true') {
        return;
      }

      // Mark as initialized
      pill.dataset.categoryPillInitialized = 'true';

      const handlePillClick = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Mark this event as a filter change for scroll handling
        e.shouldScrollToTop = true;

        // Identify pill type
        const pillType = pill.getAttribute('data-category-pill');
        const isAllPill = pillType === 'all';
        const isTagPill = pill.getAttribute('data-category-type') === 'tag';
        const wasActive = pill.classList.contains('active');

        // Build new URL parameters
        const newParams = FacetFiltersForm.buildPillFilterParams({
          wasActive,
          isAllPill,
          isTagPill,
          pill,
          currentUrl: window.location.search
        });

        // Update pill active states
        FacetFiltersForm.updatePillActiveStates(pill, wasActive, isAllPill);

        // Trigger AJAX page reload
        FacetFiltersForm.renderPage(newParams, e, true);
      };

      pill.addEventListener('click', handlePillClick);
    });
  }

  // Build filter parameters for pill clicks
  static buildPillFilterParams({ wasActive, isAllPill, isTagPill, pill, currentUrl }) {
    const currentParams = new URLSearchParams(currentUrl);
    const newParams = new URLSearchParams();

    // Preserve sort_by - check sessionStorage (for collection tabs), URL, and DOM state
    const root = FacetFiltersForm.getScopeRoot();
    const sortSelect = root.querySelector('select[name="sort_by"], select[id^="CollectionSortBy"]');
    const defaultSort = sortSelect ? sortSelect.getAttribute('data-default-sort') || 'manual' : 'manual';

    let sortBy = null;

    // For collection tabs, try to get sort from sessionStorage first
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs) {
      const tabContent = pill.closest('.tab-content');
      if (tabContent && typeof window.getTabFilterState === 'function') {
        const tabIndex = tabContent.dataset.tab;
        const collectionHandle = tabContent.dataset.collectionHandle;
        const savedState = window.getTabFilterState(tabIndex, collectionHandle);
        if (savedState && savedState.sortBy) {
          sortBy = savedState.sortBy;
        }
      }
    }

    // Fallback to URL or DOM select element
    if (!sortBy) {
      sortBy = currentParams.get('sort_by');
    }
    if (!sortBy && sortSelect) {
      sortBy = sortSelect.value;
    }

    // Add sort_by to params if it's not the default
    if (sortBy && sortBy !== defaultSort && sortBy !== '') {
      newParams.set('sort_by', sortBy);
    }

    // Preserve non-category, non-tag filter parameters (like price, availability, etc.)
    for (const [key, value] of currentParams.entries()) {
      if (key !== 'filter.p.product_type' &&
          key !== 'filter.p.tag' &&
          key !== 'sort_by' &&
          key !== 'page') {
        newParams.append(key, value);
      }
    }

    // Add filters based on pill type
    if (!isAllPill && !wasActive) {
      if (isTagPill) {
        // Add the pill's tag filter (Best Selling's best-seller tag, or Flares & Straight Legs)
        const tagValue = pill.getAttribute('data-tag-values');
        if (tagValue) {
          newParams.append('filter.p.tag', tagValue.trim());
        }
      } else {
        // Add category product type filter
        const categoryValue = pill.getAttribute('data-category-value');
        if (categoryValue) {
          newParams.append('filter.p.product_type', categoryValue);
        }
      }
    }
    // If wasActive or isAllPill, no category/tag filters are added (shows all)

    // Preserve wishlist parameter if collection tab has wishlist_lightbox enabled
    if (FacetFiltersForm.hasWishlistLightbox()) {
      newParams.set('wishlist', 'true');
    }

    return newParams.toString();
  }

  // Update pill active states after a click
  static updatePillActiveStates(clickedPill, wasActive, isAllPill) {
    // Scope to current tab if in collection tabs
    const root = FacetFiltersForm.getScopeRoot();

    // Remove active class from all pills in the current scope
    root.querySelectorAll('.category-pill').forEach(p => p.classList.remove('active'));

    // Determine which pill should be active
    if (isAllPill || wasActive) {
      // If "All" was clicked OR if any pill was clicked while active (deselecting it)
      // Activate the "All" pill
      const allPill = root.querySelector('.category-pill[data-category-pill="all"]');
      if (allPill) {
        allPill.classList.add('active');
      }
    } else {
      // Activate the clicked pill (it wasn't active before)
      clickedPill.classList.add('active');
    }
  }

  // Update active state of category pills based on URL
  static updateCategoryPillsActiveState() {
    try {
      // Scope to current tab if in collection tabs
      const root = FacetFiltersForm.getScopeRoot();

      const urlParams = new URLSearchParams(window.location.search);
      const activeCategory = urlParams.get('filter.p.product_type');
      const activeTags = urlParams.getAll('filter.p.tag');

      // Remove active class from all pills in the current scope
      root.querySelectorAll('.category-pill').forEach(pill => {
        pill.classList.remove('active');
      });

      // Check if Best Selling tags are active (womens or mens best-seller tag, or accessories core tag)
      const bestSellingTags = ['womens-best-seller', 'mens-best-seller', 'ecom-accs-core'];
      const hasBestSellingTags = bestSellingTags.some(tag => activeTags.includes(tag));

      // Other tag pills (Flares & Straight Legs) are active when their tag is
      const activeTagPill = Array.from(root.querySelectorAll('.category-pill[data-category-type="tag"]:not([data-category-pill="best-selling"])'))
        .find(pill => activeTags.includes(pill.getAttribute('data-tag-values')));

      // Priority: Best Selling > other tag pills > Category > All
      if (hasBestSellingTags && !activeCategory) {
        // Best Selling is active - find and activate the pill in the current scope
        const bestSellingPill = root.querySelector('.category-pill[data-category-pill="best-selling"]');
        if (bestSellingPill) {
          bestSellingPill.classList.add('active');
        }
      } else if (activeTagPill && !activeCategory) {
        activeTagPill.classList.add('active');
      } else if (activeCategory) {
        // Category filter is active
        // Try to find by data-category-value attribute in the current scope
        let matchingPill = root.querySelector(`.category-pill[data-category-value="${activeCategory}"]`);

        // Fallback: try to match by href containing the category
        if (!matchingPill) {
          const encodedCategory = encodeURIComponent(activeCategory);
          root.querySelectorAll('.category-pill').forEach(pill => {
            const href = pill.getAttribute('href') || '';
            if (href.includes(`filter.p.product_type=${activeCategory}`) ||
                href.includes(`filter.p.product_type=${encodedCategory}`)) {
              matchingPill = pill;
            }
          });
        }

        if (matchingPill) {
          matchingPill.classList.add('active');
        }
      } else {
        // No category or Best Selling filter - All is active
        const allPill = root.querySelector('.category-pill[data-category-pill="all"]');
        if (allPill) {
          allPill.classList.add('active');
        }
      }
    } catch (e) {
      console.error('Error updating category pills active state:', e);
    }
  }

  // Initialize price range slider functionality
  initPriceRangeSliders() {
    const priceRangeContainers = document.querySelectorAll('.price-range-filter');

    priceRangeContainers.forEach(container => {
      // Skip if already initialized to prevent duplicate listeners and infinite loops
      if (container.dataset.priceSliderInitialized === 'true') {
        return;
      }

      container.dataset.priceSliderInitialized = 'true';

      const minSlider = container.querySelector('.price-range-slider-min');
      const maxSlider = container.querySelector('.price-range-slider-max');
      const minInput = container.querySelector('input[name="filter.v.price.gte"]');
      const maxInput = container.querySelector('input[name="filter.v.price.lte"]');
      const rangeTrack = container.querySelector('.price-range-slider-range');
      const minLabel = container.querySelector('.price-range-slider-label-min');
      const maxLabel = container.querySelector('.price-range-slider-label-max');

      if (!minSlider || !maxSlider || !minInput || !maxInput) return;

      // Flag to prevent change events during initialization
      let isInitializing = true;

      // Sync sliders with URL parameters on initialization (important for when filters are applied)
      const urlParams = new URLSearchParams(window.location.search);
      const urlMinPrice = urlParams.get('filter.v.price.gte');
      const urlMaxPrice = urlParams.get('filter.v.price.lte');

      // Set values from URL params if they exist, otherwise use input values
      if (urlMinPrice) {
        minSlider.value = urlMinPrice;
        minInput.value = urlMinPrice;
      } else if (minInput.value) {
        minSlider.value = minInput.value;
      }

      if (urlMaxPrice) {
        maxSlider.value = urlMaxPrice;
        maxInput.value = urlMaxPrice;
      } else if (maxInput.value) {
        maxSlider.value = maxInput.value;
      }

      const updateRange = () => {
        const minVal = parseInt(minSlider.value) || parseInt(minSlider.min);
        const maxVal = parseInt(maxSlider.value) || parseInt(maxSlider.max);
        const min = parseInt(minSlider.min) || 0;
        const max = parseInt(minSlider.max) || 200;

        // Ensure min doesn't exceed max
        if (minVal > maxVal - 1) {
          minSlider.value = maxVal - 1;
          minInput.value = maxVal - 1;
        }

        // Ensure max doesn't go below min
        if (maxVal < minVal + 1) {
          maxSlider.value = minVal + 1;
          maxInput.value = minVal + 1;
        }

        // Update visual range indicator
        const currentMinVal = parseInt(minSlider.value) || min;
        const currentMaxVal = parseInt(maxSlider.value) || max;
        const percentMin = ((currentMinVal - min) / (max - min)) * 100;
        const percentMax = ((currentMaxVal - min) / (max - min)) * 100;

        if (rangeTrack) {
          rangeTrack.style.left = percentMin + '%';
          rangeTrack.style.width = (percentMax - percentMin) + '%';
        }

        // Update labels position and text with clamping to prevent overflow
        if (minLabel) {
          minLabel.textContent = '$' + currentMinVal;

          // Calculate label offset based on container width
          const containerWidth = container.offsetWidth || 300;
          const labelWidth = minLabel.offsetWidth || 40;
          const minOffsetPercent = (labelWidth / 2 / containerWidth) * 100;

          // Clamp to prevent overflow at edges
          let clampedPercentMin = Math.max(minOffsetPercent, Math.min(100 - minOffsetPercent, percentMin));
          minLabel.style.left = clampedPercentMin + '%';
        }

        if (maxLabel) {
          maxLabel.textContent = '$' + currentMaxVal;

          // Calculate label offset based on container width
          const containerWidth = container.offsetWidth || 300;
          const labelWidth = maxLabel.offsetWidth || 40;
          const maxOffsetPercent = (labelWidth / 2 / containerWidth) * 100;

          // Clamp to prevent overflow at edges
          let clampedPercentMax = Math.max(maxOffsetPercent, Math.min(100 - maxOffsetPercent, percentMax));
          maxLabel.style.left = clampedPercentMax + '%';
        }
      };

      // Sync slider with input
      minSlider.addEventListener('input', () => {
        minInput.value = minSlider.value;
        updateRange();
      });

      maxSlider.addEventListener('input', () => {
        maxInput.value = maxSlider.value;
        updateRange();
      });

      // Sync input with slider
      minInput.addEventListener('input', () => {
        minSlider.value = minInput.value;
        updateRange();
      });

      maxInput.addEventListener('input', () => {
        maxSlider.value = maxInput.value;
        updateRange();
      });

      // Trigger form submission on slider release
      minSlider.addEventListener('change', () => {
        // Skip if we're still initializing
        if (isInitializing) {
          return;
        }

        const form = container.closest('form');
        const facetForm = form ? form.closest('facet-filters-form') : null;
        if (form && facetForm) {
          // Create a synthetic event with the min input as the target
          const syntheticEvent = new Event('submit', { bubbles: true, cancelable: true });
          Object.defineProperty(syntheticEvent, 'target', { value: minInput, enumerable: true });
          facetForm.onSubmitHandler(syntheticEvent);
        }
      });

      maxSlider.addEventListener('change', () => {
        // Skip if we're still initializing
        if (isInitializing) {
          return;
        }

        const form = container.closest('form');
        const facetForm = form ? form.closest('facet-filters-form') : null;
        if (form && facetForm) {
          // Create a synthetic event with the max input as the target
          const syntheticEvent = new Event('submit', { bubbles: true, cancelable: true });
          Object.defineProperty(syntheticEvent, 'target', { value: maxInput, enumerable: true });
          facetForm.onSubmitHandler(syntheticEvent);
        }
      });

      // Trigger form submission on input blur (when user finishes typing)
      minInput.addEventListener('blur', () => {
        const form = container.closest('form');
        const facetForm = form ? form.closest('facet-filters-form') : null;
        if (form && facetForm) {
          // Create a synthetic event with the min input as the target
          const syntheticEvent = new Event('submit', { bubbles: true, cancelable: true });
          Object.defineProperty(syntheticEvent, 'target', { value: minInput, enumerable: true });
          facetForm.onSubmitHandler(syntheticEvent);
        }
      });

      maxInput.addEventListener('blur', () => {
        const form = container.closest('form');
        const facetForm = form ? form.closest('facet-filters-form') : null;
        if (form && facetForm) {
          // Create a synthetic event with the max input as the target
          const syntheticEvent = new Event('submit', { bubbles: true, cancelable: true });
          Object.defineProperty(syntheticEvent, 'target', { value: maxInput, enumerable: true });
          facetForm.onSubmitHandler(syntheticEvent);
        }
      });

      // Initialize range visual
      updateRange();

      // Mark initialization as complete after a short delay to ensure all events have settled
      setTimeout(() => {
        isInitializing = false;
      }, 100);
    });
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      // Ensure checked states are synchronized after browser navigation - URL has changed
      FacetFiltersForm.syncCheckedStatesWithURL(true);
      // Also update category pills active state
      FacetFiltersForm.updateCategoryPillsActiveState();
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  // Determine the scope root for operations. If inside collection tabs, scope to the visible tab.
  static getScopeRoot() {
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs) {
      const activeTabContent = collectionTabs.querySelector('.tab-content.visible');
      return activeTabContent || collectionTabs;
    }
    return document;
  }

  // Check if the active collection tab has wishlist_lightbox enabled
  static hasWishlistLightbox() {
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs) {
      const activeTabContent = collectionTabs.querySelector('.tab-content.visible');
      return activeTabContent && activeTabContent.classList.contains('wishlist-lightbox');
    }
    return false;
  }

  // Get the active tab index if within tabs
  static getActiveTabIndex() {
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs) {
      const activeTab = collectionTabs.querySelector('.tab.active');
      if (activeTab && activeTab.dataset.tab) {
        return activeTab.dataset.tab;
      }
    }
    return null;
  }

  // Handle single color selection - uncheck other color checkboxes when one is selected
  handleSingleColorSelection(event) {
    const clickedCheckbox = event.target;

    // If the checkbox was just checked, uncheck all other color checkboxes
    if (clickedCheckbox.checked) {
      // Find all color filter checkboxes across the entire document (both desktop and mobile)
      const allColorCheckboxes = document.querySelectorAll('.color-filter-checkbox, input[data-color-filter="true"]');

      allColorCheckboxes.forEach(checkbox => {
        // Uncheck all other color checkboxes except the one that was just clicked
        if (checkbox !== clickedCheckbox && checkbox.checked) {
          checkbox.checked = false;
        }
      });
    }
  }

  // Add mobile color selection handler
  addMobileColorSelectionHandler() {
    // Use event delegation to handle mobile facets that might be dynamically loaded
    document.addEventListener('change', (event) => {
      if (event.target && (event.target.classList.contains('color-filter-checkbox') ||
          event.target.hasAttribute('data-color-filter'))) {
        this.handleSingleColorSelection(event);
      }
    });
  }

  // Shared static method to adjust select element width based on content
  static adjustSelectWidth(selectElement) {
    if (!selectElement) return;

    // Skip mobile selects in drawer (they use full width layout)
    if (selectElement.classList.contains('mobile-facets__sort-select')) return;

    // Skip hidden elements
    if (selectElement.offsetParent === null) return;

    // Get the parent container to check for label
    const container = selectElement.closest('.select');
    if (!container) return;

    const label = container.querySelector('.facet-filters__label');
    const icon = container.querySelector('.facet-filters__icon');

    // Create a hidden span to measure text width
    const measureSpan = document.createElement('span');
    measureSpan.style.cssText = `
      position: absolute;
      visibility: hidden;
      white-space: nowrap;
      font-family: inherit;
      font-size: inherit;
      font-weight: inherit;
      letter-spacing: inherit;
    `;
    document.body.appendChild(measureSpan);

    // Copy the computed styles from the select
    const computedStyle = window.getComputedStyle(selectElement);
    measureSpan.style.fontFamily = computedStyle.fontFamily;
    measureSpan.style.fontSize = computedStyle.fontSize;
    measureSpan.style.fontWeight = computedStyle.fontWeight;
    measureSpan.style.letterSpacing = computedStyle.letterSpacing;

    // Get the current selected option text
    const selectedText = selectElement.options[selectElement.selectedIndex]?.text || '';
    measureSpan.textContent = selectedText;

    // Measure the text width
    const textWidth = measureSpan.offsetWidth;

    // Clean up
    document.body.removeChild(measureSpan);

    // Calculate total width needed
    // Icon width (1rem = ~16px) + label width + option text + padding (1rem left + 1rem right) + buffer
    const fontSize = parseFloat(computedStyle.fontSize) || 16;
    const iconWidth = icon ? fontSize * 1 : 0; // 1rem for icon
    const labelWidth = label ? label.offsetWidth : 0;
    const paddingLeft = fontSize * 1; // 1rem
    const paddingRight = fontSize * 1; // 1rem
    const buffer = 24; // Extra space for comfort

    const totalWidth = iconWidth + labelWidth + textWidth + paddingLeft + paddingRight + buffer;

    // Set the select element width
    selectElement.style.width = `${totalWidth}px`;
  }

  // Initialize dynamic width for sort select elements
  initDynamicSelectWidth() {
    // Find all sort select elements
    const sortSelects = this.querySelectorAll('.facet-filters__sort, .mobile-facets__sort .select__select');

    sortSelects.forEach(selectElement => {
      // Skip mobile selects
      if (selectElement.classList.contains('mobile-facets__sort-select')) return;

      // Skip if already initialized by initSortSelectListeners
      if (selectElement.dataset.widthInitialized === 'true') return;

      // Mark as initialized
      selectElement.dataset.widthInitialized = 'true';

      // Set initial width
      FacetFiltersForm.adjustSelectWidth(selectElement);

      // Update width on change (only if not already handled by sort listener)
      if (selectElement.dataset.sortListenerInitialized !== 'true') {
        selectElement.addEventListener('change', () => {
          FacetFiltersForm.adjustSelectWidth(selectElement);
        });
      }
    });

    // Also handle after page re-renders
    const observer = new MutationObserver(() => {
      const selects = this.querySelectorAll('.facet-filters__sort, .mobile-facets__sort .select__select');
      selects.forEach(selectElement => {
        if (selectElement.classList.contains('mobile-facets__sort-select')) return;
        // Skip if already initialized (either by this method or by initSortSelectListeners)
        if (selectElement.dataset.widthInitialized === 'true') return;

        selectElement.dataset.widthInitialized = 'true';

        // Set width
        FacetFiltersForm.adjustSelectWidth(selectElement);

        // Update width on change (only if not already handled by sort listener)
        if (selectElement.dataset.sortListenerInitialized !== 'true') {
          selectElement.addEventListener('change', () => {
            FacetFiltersForm.adjustSelectWidth(selectElement);
          });
        }
      });
    });

    observer.observe(this, { childList: true, subtree: true });
  }

  // Static method to reinitialize select widths for visible elements (used when tabs become visible)
  static reinitializeSelectWidths() {
    // Find all visible sort select elements in the current scope
    const root = FacetFiltersForm.getScopeRoot();
    const sortSelects = root.querySelectorAll('.facet-filters__sort, .mobile-facets__sort .select__select');

    sortSelects.forEach(selectElement => {
      // Skip mobile selects
      if (selectElement.classList.contains('mobile-facets__sort-select')) return;

      // Recalculate width
      FacetFiltersForm.adjustSelectWidth(selectElement);
    });
  }

  // Open filter sections that have active values
  static openActiveFilters() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const urlParams = new URLSearchParams(window.location.search);

      // Find all filter details elements
      const filterDetails = root.querySelectorAll('details.js-filter');

      filterDetails.forEach((details) => {
        const detailsId = details.id || 'unknown';

        // Check if this filter section has any checked checkboxes
        const checkedCheckboxes = details.querySelectorAll('input[type="checkbox"]:checked[name^="filter."]');

        // Also check for color filter checkboxes that should be checked based on URL
        // even if they're not marked as checked yet
        const colorCheckboxes = details.querySelectorAll('input[type="checkbox"][name="filter.p.tag"][data-color-filter="true"]');
        let hasActiveColorFilter = false;
        if (colorCheckboxes.length > 0) {
          // Get all color tags from URL
          const colorTags = urlParams.getAll('filter.p.tag').filter(tag => tag.includes('colour:'));
          if (colorTags.length > 0) {
            hasActiveColorFilter = true;
          }
        }

        // Check if this is the price filter with active values
        const priceMinInput = details.querySelector('input[name="filter.v.price.gte"]');
        const priceMaxInput = details.querySelector('input[name="filter.v.price.lte"]');
        let hasPriceFilter = false;

        if (priceMinInput || priceMaxInput) {
          const urlMinPrice = urlParams.get('filter.v.price.gte');
          const urlMaxPrice = urlParams.get('filter.v.price.lte');

          if (priceMinInput && urlMinPrice) {
            const defaultMin = priceMinInput.getAttribute('data-price-min');
            if (urlMinPrice != defaultMin) {
              hasPriceFilter = true;
            }
          }

          if (priceMaxInput && urlMaxPrice) {
            const defaultMax = priceMaxInput.getAttribute('data-price-max');
            if (urlMaxPrice != defaultMax) {
              hasPriceFilter = true;
            }
          }
        }

        // Open the details if it has active filters
        if (checkedCheckboxes.length > 0 || hasPriceFilter || hasActiveColorFilter) {
          details.open = true;

          // Trigger the toggle event to update refinement menu classes
          details.dispatchEvent(new Event('toggle'));
        }
      });
    } catch (e) {
      console.error('Error opening active filters:', e);
    }
  }

  static toggleActiveFacets(disable = true) {
    const root = FacetFiltersForm.getScopeRoot();
    root.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // Show/hide "Clear all" based on presence of filter params in URL
  static updateClearAllVisibility() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const urlParams = new URLSearchParams(window.location.search);
      const hasFilterParams = Array.from(urlParams.keys()).some((key) => key.startsWith('filter.'));
      const wrappers = root.querySelectorAll('.active-facets__button-wrapper');
      wrappers.forEach((wrapper) => {
        wrapper.style.display = hasFilterParams ? '' : 'none';
      });
    } catch (e) {
      // no-op
    }
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    // Cancel any pending fetch requests
    if (FacetFiltersForm.abortController) {
      FacetFiltersForm.abortController.abort();
    }

    // Increment request ID to track this request
    FacetFiltersForm.requestId++;
    const currentRequestId = FacetFiltersForm.requestId;

    // Create new abort controller for this request
    FacetFiltersForm.abortController = new AbortController();

    // Allow new renders to start (remove the blocking logic)
    FacetFiltersForm.isRendering = true;
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const root = FacetFiltersForm.getScopeRoot();
    const countContainer = root.getElementById ? root.getElementById('ProductCount') : root.querySelector('#ProductCount');
    const countContainerDesktop = root.getElementById ? root.getElementById('ProductCountDesktop') : root.querySelector('#ProductCountDesktop');
    const loadingSpinners = root.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const rootGridContainer = root.getElementById ? root.getElementById('ProductGridContainer') : root.querySelector('#ProductGridContainer');
    if (rootGridContainer) {
      const collectionEl = rootGridContainer.querySelector('.collection');
      if (collectionEl) collectionEl.classList.add('loading');
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    // Update URL hash FIRST so it's available when updateCategoryPillsActiveState is called
    const collectionTabs = document.querySelector('.collection-tabs');
    if (updateURLHash && !collectionTabs) {
      FacetFiltersForm.updateURLHash(searchParams);
    }

    // In collection tabs the response belongs to the tab that asked for it. If the
    // shopper has switched tabs by the time it lands, that tab paints it when it's
    // shown again (component-collection-tabs.js), not the tab now on screen.
    const requestTab = collectionTabs ? collectionTabs.querySelector('.tab-content.visible') : null;
    if (requestTab) requestTab.dataset.facetsPending = searchParams || '';

    sections.forEach((section) => {
      // Check if we're in a collection tabs context - search from document level since root might be scoped
      let baseUrl = window.location.pathname;
      let sectionId = section.section;
      let isInCollectionTabs = false;

      // Check if we're on a search page
      const isSearchPage = window.location.pathname.includes('/search');

      if (collectionTabs) {
        // Get the active tab's collection URL
        const activeTab = collectionTabs.querySelector('.tab.active');

        if (activeTab) {
          const tabIndex = activeTab.dataset.tab;
          const tabContent = collectionTabs.querySelector(`.tab-content[data-tab="${tabIndex}"].visible`);

          if (tabContent && tabContent.dataset.collectionUrl) {
            isInCollectionTabs = true;
            // Use the collection URL from the tab content data attribute
            // Strip any existing query parameters from the base URL
            baseUrl = tabContent.dataset.collectionUrl.split('?')[0];
            // For collection tabs, fetch the standard collection product grid section
            // This ensures we get properly filtered products without the full page structure
            sectionId = 'main-collection-product-grid';
          }
        }
      }

      // Ensure baseUrl doesn't contain query parameters (strip them if present)
      baseUrl = baseUrl.split('?')[0];

      // For search pages, preserve the search query parameter
      // Build URL using URLSearchParams for proper encoding of all parameter values
      let url;
      if (isSearchPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const searchQuery = currentParams.get('q');
        const searchPrefix = currentParams.get('options[prefix]');

        // Rebuild URL with search parameters first, then filters
        if (searchQuery) {
          const urlParams = new URLSearchParams();
          // Add section_id first
          urlParams.set('section_id', sectionId);
          // Add search params
          urlParams.set('q', searchQuery);
          if (searchPrefix) {
            urlParams.set('options[prefix]', searchPrefix);
          }
          // Add all filter params from searchParams string
          const filterParams = new URLSearchParams(searchParams);
          for (const [key, value] of filterParams.entries()) {
            // Skip q and options[prefix] if they exist in searchParams (to avoid duplicates)
            if (key !== 'q' && key !== 'options[prefix]') {
              urlParams.append(key, value);
            }
          }

          // Build URL with properly encoded params
          url = `${baseUrl}?${urlParams.toString()}`;
        } else {
          // No search query, build standard URL
          const urlParams = new URLSearchParams();
          urlParams.set('section_id', sectionId);
          // Add all params from searchParams string
          const filterParams = new URLSearchParams(searchParams);
          for (const [key, value] of filterParams.entries()) {
            urlParams.append(key, value);
          }
          url = `${baseUrl}?${urlParams.toString()}`;
        }
      } else {
        // For non-search pages, use URLSearchParams to ensure proper encoding
        const urlParams = new URLSearchParams();
        urlParams.set('section_id', sectionId);
        // Add all params from searchParams string
        const filterParams = new URLSearchParams(searchParams);
        for (const [key, value] of filterParams.entries()) {
          urlParams.append(key, value);
        }
        url = `${baseUrl}?${urlParams.toString()}`;
      }

      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event, currentRequestId, requestTab)
        : FacetFiltersForm.renderSectionFromFetch(url, event, currentRequestId, requestTab);
    });
  }

  static renderSectionFromFetch(url, event, requestId, requestTab) {
    fetch(url, { signal: FacetFiltersForm.abortController.signal })
      .then((response) => {
        // Check if this request is still the latest
        if (requestId !== FacetFiltersForm.requestId) {
          throw new Error('Stale request');
        }
        return response.text();
      })
      .then((responseText) => {
        // Double-check request ID after async operation
        if (requestId !== FacetFiltersForm.requestId) {
          return; // Ignore this response, a newer one is being processed
        }

        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];

        // The shopper switched tabs while this loaded: keep it cached for its own tab
        if (requestTab && !requestTab.classList.contains('visible')) {
          FacetFiltersForm.isRendering = false;
          return;
        }
        if (requestTab) delete requestTab.dataset.facetsPending;

        // Check if we're in collection tabs context
        const collectionTabs = document.querySelector('.collection-tabs');
        const isCollectionTabs = collectionTabs !== null;

        // Check if we're on a search page
        const isSearchPage = window.location.pathname.includes('/search');

        // Only update filters if we're NOT in collection tabs context
        // For search pages, don't update filter options to keep them persistent
        if (!isCollectionTabs && !isSearchPage) {
          FacetFiltersForm.renderFilters(html, event);
        }

        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

        // For collection tabs and search pages, skip filter-related cleanup since filters don't change
        if (!isCollectionTabs && !isSearchPage) {
          // Re-bind refinement menus after fetch renders
          FacetFiltersForm.wireRefinementMenus();
          FacetFiltersForm.wireMobileRefinementMenus();
          // Defensive cleanup of any stray boolean options after render
          FacetFiltersForm.removeBooleanOptions();
          // Remove duplicate groups with the same handle after render
          FacetFiltersForm.dedupeFilterGroups();
          // Re-bind mobile facets close handler after fetch renders
          FacetFiltersForm.addMobileFacetsCloseHandler();
          // Ensure clear-all reflects current URL state
          FacetFiltersForm.updateClearAllVisibility();
          // Sync checked states after successful fetch - URL has been updated by now
          FacetFiltersForm.syncCheckedStatesWithURL(true);
          // Clean up temporary filter-selected classes
          FacetFiltersForm.cleanupFilterSelectedClasses();
          // Update category pills active state (no need to re-initialize, just update active state)
          FacetFiltersForm.updateCategoryPillsActiveState();
        } else if (isSearchPage) {
          // For search pages, only sync checked states without updating filter options
          FacetFiltersForm.syncCheckedStatesWithURL(true);
          // Clean up temporary filter-selected classes
          FacetFiltersForm.cleanupFilterSelectedClasses();
          // Update active facets pills to reflect current filters
          const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
          FacetFiltersForm.renderActiveFacets(parsedHTML);
        } else if (isCollectionTabs) {
          // For collection tabs, restore filter state from sessionStorage after AJAX
          // UNLESS we just cleared all filters
          if (window.skipCollectionTabRestoration) {
            // Reset the flag after a delay to allow normal restoration for subsequent actions
            setTimeout(() => {
              window.skipCollectionTabRestoration = false;
            }, 500);
          } else {
            // The server-rendered HTML checks URL params (which don't exist in tabs)
            // so checkboxes will be wrong unless we restore from sessionStorage
            setTimeout(() => {
              const activeTabContent = document.querySelector('.collection-tabs .tab-content.visible');
              if (activeTabContent && typeof restoreFilterStates === 'function') {
                const tabIndex = activeTabContent.dataset.tab;
                const collectionHandle = activeTabContent.dataset.collectionHandle;

                // Get saved state from sessionStorage
                if (typeof getTabFilterState === 'function') {
                  const savedState = getTabFilterState(tabIndex, collectionHandle);
                  if (savedState && savedState.filterCheckboxes) {
                    restoreFilterStates(activeTabContent, savedState.filterCheckboxes);
                  }
                }
              }
            }, 100); // Increased delay to ensure DOM is fully updated
          }
        }

        // Re-initialize price range sliders after fetch (both regular and tabs)
        if (!isCollectionTabs && !isSearchPage) {
          const facetForm = document.querySelector('facet-filters-form');
          if (facetForm && facetForm.initPriceRangeSliders) {
            facetForm.initPriceRangeSliders();
          }

          // Re-initialize sort select listeners after fetch
          if (facetForm && facetForm.initSortSelectListeners) {
            const form = facetForm.querySelector('form');
            if (form) {
              facetForm.initSortSelectListeners(form);
            }
          }

          // Open filter sections that have active values after fetch
          FacetFiltersForm.openActiveFilters();
        }

        // Reset rendering flag
        FacetFiltersForm.isRendering = false;

        // Scroll to facet form if this was triggered by a filter change
        if (event && event.shouldScrollToTop) {
          FacetFiltersForm.scrollToFacetForm();
        }
      })
      .catch((error) => {
        // Ignore abort errors (expected when cancelling requests)
        if (error.name === 'AbortError' || error.message === 'Stale request') {
          return;
        }
        console.error('Error fetching facets:', error);
        FacetFiltersForm.isRendering = false;
      });
  }

  static renderSectionFromCache(filterDataUrl, event, requestId, requestTab) {
    // Check if this request is still the latest
    if (requestId !== FacetFiltersForm.requestId) {
      return; // Ignore this cached response, a newer one is being processed
    }
    if (requestTab) delete requestTab.dataset.facetsPending;

    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;

    // Check if we're in collection tabs context
    const collectionTabs = document.querySelector('.collection-tabs');
    const isCollectionTabs = collectionTabs !== null;

    // Check if we're on a search page
    const isSearchPage = window.location.pathname.includes('/search');

    // Only update filters if we're NOT in collection tabs context
    // For search pages, don't update filter options to keep them persistent
    if (!isCollectionTabs && !isSearchPage) {
      FacetFiltersForm.renderFilters(html, event);
    }

    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);

    // For collection tabs and search pages, skip filter-related cleanup since filters don't change
    if (!isCollectionTabs && !isSearchPage) {
      // Re-bind refinement menus after cache renders
      FacetFiltersForm.wireRefinementMenus();
      FacetFiltersForm.wireMobileRefinementMenus();
      // Defensive cleanup of any stray boolean options after render
      FacetFiltersForm.removeBooleanOptions();
      // Remove duplicate groups with the same handle after render
      FacetFiltersForm.dedupeFilterGroups();
      // Re-bind mobile facets close handler after cache renders
      FacetFiltersForm.addMobileFacetsCloseHandler();
      // Ensure clear-all reflects current URL state
      FacetFiltersForm.updateClearAllVisibility();
      // Sync checked states after cache render - URL has been updated by now
      FacetFiltersForm.syncCheckedStatesWithURL(true);
      // Clean up temporary filter-selected classes
      FacetFiltersForm.cleanupFilterSelectedClasses();
      // Update category pills active state (no need to re-initialize, just update active state)
      FacetFiltersForm.updateCategoryPillsActiveState();
    } else if (isSearchPage) {
      // For search pages, only sync checked states without updating filter options
      FacetFiltersForm.syncCheckedStatesWithURL(true);
      // Clean up temporary filter-selected classes
      FacetFiltersForm.cleanupFilterSelectedClasses();
      // Update active facets pills to reflect current filters
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      FacetFiltersForm.renderActiveFacets(parsedHTML);
    } else if (isCollectionTabs) {
      // For collection tabs, restore filter state from sessionStorage after AJAX
          // UNLESS we just cleared all filters
          if (window.skipCollectionTabRestoration) {
            // Reset the flag after a delay to allow normal restoration for subsequent actions
            setTimeout(() => {
              window.skipCollectionTabRestoration = false;
            }, 500);
          } else {
            // The server-rendered HTML checks URL params (which don't exist in tabs)
            // so checkboxes will be wrong unless we restore from sessionStorage
            setTimeout(() => {
              const activeTabContent = document.querySelector('.collection-tabs .tab-content.visible');
              if (activeTabContent && typeof restoreFilterStates === 'function') {
                const tabIndex = activeTabContent.dataset.tab;
                const collectionHandle = activeTabContent.dataset.collectionHandle;

                // Get saved state from sessionStorage
                if (typeof getTabFilterState === 'function') {
                  const savedState = getTabFilterState(tabIndex, collectionHandle);
                  if (savedState && savedState.filterCheckboxes) {
                    restoreFilterStates(activeTabContent, savedState.filterCheckboxes);
                  }
                }
              }
            }, 100); // Increased delay to ensure DOM is fully updated
          }
    }

    // Re-initialize price range sliders after cache render (both regular and tabs)
    if (!isCollectionTabs && !isSearchPage) {
      const facetForm = document.querySelector('facet-filters-form');
      if (facetForm && facetForm.initPriceRangeSliders) {
        facetForm.initPriceRangeSliders();
      }

      // Re-initialize sort select listeners after cache render
      if (facetForm && facetForm.initSortSelectListeners) {
        const form = facetForm.querySelector('form');
        if (form) {
          facetForm.initSortSelectListeners(form);
        }
      }

      // Open filter sections that have active values after cache render
      FacetFiltersForm.openActiveFilters();
    }

    // Reset rendering flag
    FacetFiltersForm.isRendering = false;

    // Scroll to facet form if this was triggered by a filter change
    if (event && event.shouldScrollToTop) {
      FacetFiltersForm.scrollToFacetForm();
    }
  }

  static renderProductGridContainer(html) {
    // Skip rendering if infinite scroll is loading (to prevent clearing appended products)
    if (window.infiniteScrollLoading) {
      return;
    }

    const root = FacetFiltersForm.getScopeRoot();
    const productGridContainer = (root.getElementById ? root.getElementById('ProductGridContainer') : root.querySelector('#ProductGridContainer'));
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const tabIndex = FacetFiltersForm.getActiveTabIndex();
    let sourceContainer = null;

    // For collection tabs, we need to find the product grid from the fetched collection section
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs && tabIndex !== null) {
      // The response is a full section HTML - find the product grid container within it
      // Look for different possible container structures
      sourceContainer = parsed.querySelector('#ProductGridContainer') ||
                       parsed.querySelector('.product-grid-container') ||
                       parsed.querySelector('#product-grid')?.parentElement;

      // If we found the container in a nested structure, try to get its parent container
      if (!sourceContainer) {
        const productGrid = parsed.querySelector('#product-grid');
        if (productGrid) {
          // Get the wrapping container that has both the grid and any other elements
          sourceContainer = productGrid.closest('.product-grid-container, #ProductGridContainer');
        }
      }
    } else {
      // For non-tab contexts, use the standard container
      sourceContainer = parsed.getElementById('ProductGridContainer');
    }

    if (productGridContainer && sourceContainer) {
      productGridContainer.innerHTML = sourceContainer.innerHTML;

      // Re-initialize any scripts that might be needed for the new content
      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger();
      }
    }

    if (productGridContainer) {
      productGridContainer
        .querySelectorAll('.scroll-trigger')
        .forEach((element) => {
          element.classList.add('scroll-trigger--cancel');
        });

      // Trigger lazy loading for dynamically loaded product images
      if (window.lazyloadPolyfill) {
        window.lazyloadPolyfill(productGridContainer);
      }

      // Also trigger lazysizes if available for lazyload class images
      if (window.lazySizes) {
        // Trigger lazysizes to check for new lazyload elements
        productGridContainer.querySelectorAll('img.lazyload').forEach((img) => {
          window.lazySizes.loader.unveil(img);
        });
        // Also trigger a general recheck for any missed elements
        window.lazySizes.autoSizer.checkElems();
      } else {
        // Fallback if lazySizes isn't loaded yet - manually process lazyload images
        productGridContainer.querySelectorAll('img.lazyload').forEach((img) => {
          if (img.dataset.src && !img.src) {
            img.src = img.dataset.src;
          }
          if (img.dataset.srcset && !img.srcset) {
            img.srcset = img.dataset.srcset;
          }
          img.classList.remove('lazyload');
          img.classList.add('lazyloaded');
        });
      }

      // Trigger currency conversion if available
      if (window.convertCurrency) {
        window.convertCurrency(productGridContainer);
      }
    }

    // Notify collection tabs (and others) that the product grid has been re-rendered
    // so they can re-initialize infinite scroll and auto-load the next page
    document.dispatchEvent(new CustomEvent('productGridRendered'));
  }

  static renderProductCount(html) {
    const root = FacetFiltersForm.getScopeRoot();
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const tabIndex = FacetFiltersForm.getActiveTabIndex();
    let sourceCount = null;

    // For collection tabs, extract product count from the fetched section
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs && tabIndex !== null) {
      // Try to find product count in various possible locations in the response
      const mainCount = parsed.querySelector('#ProductCount') ||
                       parsed.querySelector('.product-count span') ||
                       parsed.querySelector('#ProductCountDesktop');
      sourceCount = mainCount ? mainCount.innerHTML : '';
    } else {
      // For non-tab contexts, use the standard container
      const fallback = parsed.getElementById('ProductCount');
      sourceCount = fallback ? fallback.innerHTML : '';
    }

    const container = (root.getElementById ? root.getElementById('ProductCount') : root.querySelector('#ProductCount'));
    const containerDesktop = (root.getElementById ? root.getElementById('ProductCountDesktop') : root.querySelector('#ProductCountDesktop'));
    if (container && sourceCount) {
      container.innerHTML = sourceCount;
      container.classList.remove('loading');
    }
    if (containerDesktop && sourceCount) {
      containerDesktop.innerHTML = sourceCount;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = root.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const root = FacetFiltersForm.getScopeRoot();
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const tabIndex = FacetFiltersForm.getActiveTabIndex();
    const scopeFromFetch = tabIndex !== null
      ? parsedHTML.querySelector(`.tab-content[data-tab="${tabIndex}"]`)
      : parsedHTML;
    const facetDetailsElementsFromFetch = (scopeFromFetch || parsedHTML).querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = root.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement && elementToRender.parentElement.id) {
          const parentInRoot = root.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (parentInRoot) parentInRoot.before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // Make sure refinement menus reflect open state after DOM updates
    FacetFiltersForm.wireRefinementMenus();
    FacetFiltersForm.wireMobileRefinementMenus();
    // Re-bind mobile facets close handler after DOM updates
    FacetFiltersForm.addMobileFacetsCloseHandler();
    // Defensive cleanup of any stray boolean options after filters update
    FacetFiltersForm.removeBooleanOptions();
    // Remove duplicate groups with the same handle after filters update
    FacetFiltersForm.dedupeFilterGroups();
    // Open filter sections that have active values after filters update
    FacetFiltersForm.openActiveFilters();

    if (countsToRender) {
      const closestJSFilter = event.target.closest('.js-filter');
      const closestJSFilterID = closestJSFilter ? closestJSFilter.id : null;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, closestJSFilter);
        const targetEl = (root.getElementById ? root.getElementById(closestJSFilterID) : root.querySelector(`#${closestJSFilterID}`));
        FacetFiltersForm.renderMobileCounts(countsToRender, targetEl);

        const newFacetDetailsElement = targetEl;
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  // Clean up temporary filter-selected classes after AJAX render
  static cleanupFilterSelectedClasses() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const allLabelsWithClass = root.querySelectorAll('label.filter-selected');
      allLabelsWithClass.forEach(label => {
        label.classList.remove('filter-selected');
      });
    } catch (e) {
      console.error('Error cleaning up filter-selected classes:', e);
    }
  }

  // Sync all filter pill checked states with current URL parameters
  static syncCheckedStatesWithURL(skipChangeEvents = false) {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const urlParams = new URLSearchParams(window.location.search);

      // Get all filter parameters from URL
      const urlFilterParams = {};
      for (const [key, value] of urlParams.entries()) {
        if (key.startsWith('filter.')) {
          if (!urlFilterParams[key]) {
            urlFilterParams[key] = [];
          }
          urlFilterParams[key].push(value);
        }
      }

      // Find all filter checkboxes in the refinement menus (both custom and native)
      const filterCheckboxes = root.querySelectorAll('.refinementMenu input[type="checkbox"][name^="filter."], .facets-wrap input[type="checkbox"][name^="filter."]');

      filterCheckboxes.forEach(checkbox => {
        const paramName = checkbox.name;
        const paramValue = checkbox.value;

        // Check if this checkbox should be checked based on URL parameters
        const shouldBeChecked = urlFilterParams[paramName] && urlFilterParams[paramName].includes(paramValue);

        // Update the checkbox state if it doesn't match
        if (checkbox.checked !== shouldBeChecked) {
          checkbox.checked = shouldBeChecked;

          // Only trigger change events during initial sync, not during user interactions
          if (!skipChangeEvents) {
            checkbox.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });

      // Also sync all filter checkboxes in the unified form (both custom and native)
      const allFilterCheckboxes = root.querySelectorAll('input[type="checkbox"][name^="filter."]');
      allFilterCheckboxes.forEach(checkbox => {
        const paramName = checkbox.name;
        const paramValue = checkbox.value;

        const shouldBeChecked = urlFilterParams[paramName] && urlFilterParams[paramName].includes(paramValue);

        if (checkbox.checked !== shouldBeChecked) {
          checkbox.checked = shouldBeChecked;
        }
      });

      // CRITICAL: For single-select filters, ensure only ONE checkbox is checked per group
      // This handles cases where the server might return multiple checked states
      // Also allows ALL checkboxes in a group to be unchecked (no filter selected)
      const singleSelectCheckboxes = root.querySelectorAll('input[type="checkbox"][data-single-select="true"]');
      const singleSelectGroups = {};

      // Group single-select checkboxes by their facet type/group
      singleSelectCheckboxes.forEach(checkbox => {
        const facetType = checkbox.getAttribute('data-facet-type');
        const facetGroup = checkbox.getAttribute('data-facet-group');
        const groupKey = facetType || facetGroup;

        if (groupKey) {
          if (!singleSelectGroups[groupKey]) {
            singleSelectGroups[groupKey] = [];
          }
          singleSelectGroups[groupKey].push(checkbox);
        }
      });

      // For each single-select group, ensure only the LAST checked checkbox remains checked
      // (the last one in URL params is the most recent selection)
      // If no URL params exist for this group, allow all to be unchecked
      Object.entries(singleSelectGroups).forEach(([groupKey, groupCheckboxes]) => {
        const checkedBoxes = groupCheckboxes.filter(cb => cb.checked);

        // Check if URL params actually contain any value for this group
        const hasUrlParam = groupCheckboxes.some(cb => {
          const paramName = cb.name;
          const paramValue = cb.value;
          return urlFilterParams[paramName] && urlFilterParams[paramName].includes(paramValue);
        });

        // If no URL param for this group, ensure all are unchecked
        if (!hasUrlParam && checkedBoxes.length > 0) {
          checkedBoxes.forEach(cb => {
            cb.checked = false;
          });
        }
        // If more than one is checked, uncheck all except the last one
        else if (checkedBoxes.length > 1) {
          // Uncheck all except the last
          for (let i = 0; i < checkedBoxes.length - 1; i++) {
            checkedBoxes[i].checked = false;
          }
        }
      });

    } catch (e) {
      console.error('Error syncing checked states with URL:', e);
    }
  }

  // Add/remove `.open` on refinementMenu and header when Details toggles
  static wireRefinementMenus() {
    try {
      const root = FacetFiltersForm.getScopeRoot();

      // For collection tabs, we need to scope more specifically to direct children
      let detailsList;
      const isInCollectionTabs = document.querySelector('.collection-tabs') !== null;

      if (isInCollectionTabs && root.classList && root.classList.contains('tab-content')) {
        // We're in a specific tab - only get details that are direct descendants of this tab's form
        const form = root.querySelector('#FacetFiltersForm');
        detailsList = form ? form.querySelectorAll('details.js-filter') : [];
      } else {
        // Normal context
        detailsList = root.querySelectorAll('#FacetFiltersForm details.js-filter');
      }

      detailsList.forEach((detailsEl) => {
        const menu = detailsEl.querySelector('.refinementMenu');
        const header = detailsEl.querySelector('.refinementMenuHeader');
        if (!menu && !header) return;

        const apply = () => {
          if (menu) menu.classList.toggle('open', !!detailsEl.open);
          if (header) header.classList.toggle('open', !!detailsEl.open);
        };

        // Initial state
        apply();
        // Toggle on open/close
        detailsEl.addEventListener('toggle', apply, { passive: true });
      });
    } catch (e) {
      console.error('[Facets] Error in wireRefinementMenus:', e);
    }
  }

  // Remove any options labeled strictly "true" or "false" (case-insensitive) and hide empty groups or groups with only one option
  static removeBooleanOptions() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const isBoolean = (text) => {
        if (!text) return false;
        const t = String(text).trim().toLowerCase();
        return t === 'true' || t === 'false';
      };

      // Remove labels and their inputs if label text is boolean
      root.querySelectorAll('.refinementMenu label, .facets-wrap label').forEach((label) => {
        const textEl = label.querySelector('.facet-checkbox__text, .filter-item__text');
        const text = textEl ? textEl.textContent : label.textContent;
        if (isBoolean(text)) {
          label.remove();
        }
      });

      // Hide groups that became empty or have only one option (but never hide the Sort group)
      root.querySelectorAll('details.js-filter').forEach((details) => {
        const wrapper = details.closest('.refinementButton-sort');
        const filterKey = (wrapper?.getAttribute('data-filter') || '').trim().toLowerCase();
        const isSortGroup = !!details.querySelector('select[name="sort_by"]') || filterKey === 'sort';
        const allLabels = details.querySelectorAll('.refinementMenu label, .facets-wrap label');
        const visibleLabels = Array.from(allLabels).filter(label => {
          // Check if label is actually visible (not hidden by display:none or visibility:hidden)
          // For unified form, ignore offsetParent check as mobile drawer may be transformed off-screen
          const style = window.getComputedStyle(label);
          return style.display !== 'none' && style.visibility !== 'hidden';
        });

        if (isSortGroup) {
          // Ensure visible
          wrapper?.classList.remove('hidden');
          details.removeAttribute('hidden');
          return;
        }

        // Hide if no options OR only one option
        if (visibleLabels.length <= 1) {
          wrapper?.classList.add('hidden');
          details.setAttribute('hidden', 'hidden');
        } else {
          wrapper?.classList.remove('hidden');
          details.removeAttribute('hidden');
        }
      });
    } catch (e) {
      // no-op
    }
  }

  // De-duplicate filter groups by their handle (data-filter), keeping the first occurrence
  static dedupeFilterGroups() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const containers = [];
      // Single unified form container
      const formContainer = root.querySelector('#FacetFiltersForm');
      if (formContainer) containers.push(formContainer);

      const dedupeIn = (container) => {
        const seen = new Set();
        container.querySelectorAll('.refinementButton-sort[data-filter]').forEach((wrapper) => {
          const key = (wrapper.getAttribute('data-filter') || '').trim().toLowerCase();
          if (!key) return;
          if (seen.has(key)) {
            wrapper.remove();
          } else {
            seen.add(key);
          }
        });
      };

      containers.forEach(dedupeIn);
    } catch (e) {
      // no-op
    }
  }

  // Wire mobile refinement menus for accordion behavior
  static wireMobileRefinementMenus() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      const mobileDetails = root.querySelectorAll('.mobile-vertical-filters details.js-filter');
      mobileDetails.forEach((detailsEl) => {
        const menu = detailsEl.querySelector('.refinementMenu');
        const header = detailsEl.querySelector('.refinementMenuHeader');
        if (!menu && !header) return;

        const apply = () => {
          if (menu) menu.classList.toggle('open', !!detailsEl.open);
          if (header) header.classList.toggle('open', !!detailsEl.open);
        };

        // Remove existing listeners to avoid duplicates
        detailsEl.removeEventListener('toggle', apply);

        // Initial state
        apply();
        // Toggle on open/close
        detailsEl.addEventListener('toggle', apply, { passive: true });
      });
    } catch (e) {
      // no-op
    }
  }

  // Add mobile facets header close functionality
  static addMobileFacetsCloseHandler() {
    try {
      // Get the appropriate scope (visible tab or document)
      const root = FacetFiltersForm.getScopeRoot();

      // Initialize mobile drawer functionality for unified form
      // For collection tabs, query within the visible tab; otherwise query document
      const triggers = root.querySelectorAll('.mobile-facets__trigger');
      const facetsForms = root.querySelectorAll('.facets-unified');
      const closeButtons = root.querySelectorAll('.mobile-facets__close-button');
      const applyButtons = root.querySelectorAll('.mobile-facets__apply-button');
      const footerClearAllButtons = root.querySelectorAll('.mobile-facets__clear-all-footer');

      if (triggers.length === 0 || facetsForms.length === 0) return;

      // Create backdrop if it doesn't exist
      // let backdrop = document.querySelector('.facets-backdrop');
      let backdrop = document.querySelectorAll('.facets-backdrop');
      if (!backdrop.length) {
        backdrop = document.createElement('div');
        backdrop.className = 'facets-backdrop';
        // document.body.appendChild(backdrop);
        // document.querySelector('.facets-container').appendChild(backdrop);
        document.querySelectorAll('.facets-container').forEach(el => el.appendChild(backdrop.cloneNode(true)));
        backdrop = document.querySelectorAll('.facets-backdrop');
      }

      // Attach handlers to each trigger/form pair
      triggers.forEach((trigger, index) => {
        const facetsForm = facetsForms[index] || facetsForms[0];
        const closeButton = closeButtons[index] || closeButtons[0];
        const applyButton = applyButtons[index] || applyButtons[0];
        const footerClearAllButton = footerClearAllButtons[index] || footerClearAllButtons[0];

        // Skip if already initialized
        if (trigger.dataset.mobileHandlerInitialized === 'true') {
          return;
        }

        // Mark as initialized
        trigger.dataset.mobileHandlerInitialized = 'true';

        // Open drawer
        const openDrawer = () => {
          facetsForm.classList.add('open');
          backdrop.forEach(el => el.classList.add('active'));
          document.body.style.overflow = 'hidden';
        };

        // Close drawer
        const closeDrawer = () => {
          facetsForm.classList.remove('open');
          backdrop.forEach(el => el.classList.remove('active'));
          document.body.style.overflow = '';
        };

        // Add event listeners
        trigger.addEventListener('click', openDrawer);
        if (closeButton) closeButton.addEventListener('click', closeDrawer);
        if (applyButton) applyButton.addEventListener('click', closeDrawer);
        if (footerClearAllButton) footerClearAllButton.addEventListener('click', closeDrawer);
      });

      // Backdrop closes ALL open drawers (only one should be open at a time)
      // Remove existing listener to avoid duplicates
      const existingBackdropHandler = backdrop.forEach(el => el.dataset.clickHandler);
      if (!existingBackdropHandler) {
        const closeAllDrawers = () => {
          facetsForms.forEach(form => form.classList.remove('open'));
          backdrop.forEach(el => el.classList.remove('active'));
          document.body.style.overflow = '';
        };
        backdrop.forEach(el => el.addEventListener('click', closeAllDrawers));
        backdrop.forEach(el => el.dataset.clickHandler = 'true');
      }

    } catch (e) {
      console.error('Error adding mobile facets handler:', e);
    }
  }

  // Handle mobile facets close click (legacy - kept for compatibility)
  static handleMobileFacetsClose(event) {
    try {
      const facetsForm = document.querySelector('.facets-unified');
      const backdrop = document.querySelectorAll('.facets-backdrop');

      if (facetsForm) {
        facetsForm.classList.remove('open');
      }
      if (backdrop) {
        backdrop.forEach(el => el.classList.remove('active'));
      }
      document.body.style.overflow = '';

      event.preventDefault();
      event.stopPropagation();
    } catch (e) {
      console.error('Error handling mobile facets close:', e);
    }
  }

  static renderActiveFacets(html) {
    const root = FacetFiltersForm.getScopeRoot();
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      const target = root.querySelector(selector) || document.querySelector(selector);
      if (target) target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
    // Ensure clear-all reflects current URL state after active facets render
    FacetFiltersForm.updateClearAllVisibility();

    // Re-bind event listeners for new active facet removal buttons
    root.querySelectorAll('.active-facets__button').forEach(button => {
      if (!button.hasAttribute('data-listener-bound')) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const form = document.querySelector('facet-filters-form');
          if (form) {
            form.onActiveFilterClick(e);
          }
        });
        button.setAttribute('data-listener-bound', 'true');
      }
    });
  }

  // Clean up active facets text - this functionality is now handled more efficiently in the template

  static renderAdditionalElements(html) {
    const root = FacetFiltersForm.getScopeRoot();
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      const target = root.querySelector(selector) || document.querySelector(selector);
      if (target) target.innerHTML = html.querySelector(selector).innerHTML;
    });

    // No separate mobile form - single unified form
    // Mobile drawer behavior is handled by CSS and the trigger button
    // Re-bind mobile facets close handler
    FacetFiltersForm.addMobileFacetsCloseHandler();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static scrollToFacetForm() {
    try {
      const root = FacetFiltersForm.getScopeRoot();
      // const facetForm = root.querySelector('facet-filters-form');
      // const collectionTab = root.querySelector('.collection-tabs');
      const collectionTop = document.querySelector('.product-grid-container .collection');
      const collectionTab = document.querySelector('.collection-tabs');
      const yOffset = -96; // Offset for navigation
      let y = 0;
      if (collectionTop && !collectionTab) {
        // Smooth scroll to align the top of the facet form with the top of the viewport
        y = collectionTop.getBoundingClientRect().top + window.pageYOffset + yOffset;
      } else if (collectionTab) {
        y = collectionTab.getBoundingClientRect().top + window.pageYOffset - 30;
      }
      window.scrollTo({ top: y, behavior: 'smooth' });
    } catch (e) {
      console.error('Error scrolling to facet form:', e);
    }
  }

  static updateURLHash(searchParams) {
    // For search pages, preserve the search query parameter
    const isSearchPage = window.location.pathname.includes('/search');
    let finalUrl = `${window.location.pathname}`;

    if (isSearchPage) {
      const currentParams = new URLSearchParams(window.location.search);
      const searchQuery = currentParams.get('q');
      const searchPrefix = currentParams.get('options[prefix]');

      if (searchQuery) {
        const urlParams = new URLSearchParams(searchParams);
        // Remove q and options[prefix] if they exist in searchParams (to avoid duplicates)
        urlParams.delete('q');
        urlParams.delete('options[prefix]');

        // Add search params using URLSearchParams for proper encoding
        urlParams.set('q', searchQuery);
        if (searchPrefix) {
          urlParams.set('options[prefix]', searchPrefix);
        }

        // Build the URL with properly encoded params
        const allParams = urlParams.toString();
        finalUrl += allParams ? `?${allParams}` : '';
      } else if (searchParams) {
        finalUrl += `?${searchParams}`;
      }
    } else {
      // For non-search pages, use the standard approach
      finalUrl += searchParams ? `?${searchParams}` : '';
    }

    history.pushState({ searchParams }, '', finalUrl);
  }

  static getSections() {
    const root = FacetFiltersForm.getScopeRoot();
    const productGrid = (root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid'));
    const sectionId = productGrid ? productGrid.dataset.id : (document.getElementById('product-grid') ? document.getElementById('product-grid').dataset.id : '');
    return [
      {
        section: sectionId,
      },
    ];
  }

  createSearchParams(form) {
    const params = new URLSearchParams();

    // For search pages, preserve the search query parameter
    const isSearchPage = window.location.pathname.includes('/search');
    if (isSearchPage) {
      const currentParams = new URLSearchParams(window.location.search);
      const searchQuery = currentParams.get('q');
      const searchPrefix = currentParams.get('options[prefix]');

      if (searchQuery) {
        params.set('q', searchQuery);
      }
      if (searchPrefix) {
        params.set('options[prefix]', searchPrefix);
      }
    }

    // Check if we're in collection tabs first - they need special handling
    const collectionTabs = document.querySelector('.collection-tabs');
    const isCollectionTabs = collectionTabs !== null;

    // For collection tabs, add the highlighted category pill's filter, because
    // category pills are not form inputs. Read the pill itself, not the tab's
    // saved state: a pill tap never reaches the click listener that saves it
    // (initCategoryPills stops the click), so the saved pill can be one behind,
    // and All + a colour came back empty under Best Selling's old tag.
    if (isCollectionTabs) {
      const activeTabContent = collectionTabs.querySelector('.tab-content.visible');
      const activePill = activeTabContent && activeTabContent.querySelector('.category-pill.active');

      if (activePill && activePill.getAttribute('data-category-pill') !== 'all') {
        if (activePill.getAttribute('data-category-type') === 'tag') {
          // Tag pill (Best Selling, Flares & Straight Legs) - add its tag
          const tagValue = activePill.getAttribute('data-tag-values');
          if (tagValue) {
            params.append('filter.p.tag', tagValue);
          }
        } else {
          // Regular category pill - add its product type
          const categoryValue = activePill.getAttribute('data-category-value');
          if (categoryValue) {
            params.append('filter.p.product_type', categoryValue);
          }
        }
      }
    } else {
      // Not in collection tabs - preserve existing filter parameters from URL if the form doesn't contain filter inputs
      // This is important when the sort form is separate from the filter form
      const formHasFilters = form && form.querySelectorAll('input[name^="filter."]').length > 0;

      if (!formHasFilters) {
        const currentParams = new URLSearchParams(window.location.search);
        for (const [key, value] of currentParams.entries()) {
          if (key.startsWith('filter.')) {
            params.append(key, value);
          }
        }
      }
    }

    // Collect all checked checkboxes and other form inputs from the CURRENT form only
    // Don't collect from all forms - only the one that triggered the event
    const groupedParams = {};
    let hasSizeFilter = false;

    // Process only the current form
    // For collection tabs, only process inputs from the visible tab
    if (form) {
      // Check if we're in collection tabs context
      const collectionTabs = document.querySelector('.collection-tabs');
      let inputScope = form;

      if (collectionTabs) {
        // Find the visible tab content
        const visibleTab = collectionTabs.querySelector('.tab-content.visible');
        if (visibleTab) {
          // Only query inputs within the visible tab AND within the current form
          // This prevents collecting from both desktop and mobile forms
          inputScope = visibleTab;
        }
      }

      // Query inputs only within the current form to avoid duplicates
      // Use form as the scope, but if in collection tabs, filter to only those in the visible tab
      const inputsToProcess = collectionTabs ?
        Array.from(form.querySelectorAll('input, select')).filter(input => {
          const visibleTab = collectionTabs.querySelector('.tab-content.visible');
          return visibleTab && visibleTab.contains(input);
        }) :
        Array.from(form.querySelectorAll('input, select'));

      inputsToProcess.forEach(input => {
        let name = input.name;
        let value = input.value;

        // Skip inputs without names
        if (!name) {
          return;
        }

        // Handle different input types
        if (input.type === 'checkbox' || input.type === 'radio') {
          if (!input.checked) return; // Skip unchecked boxes
        } else if (input.type === 'range') {
          // Skip range sliders - they're just for visual control, the number inputs have the actual values
          return;
        } else if (input.type === 'text' || input.type === 'number') {
          // For price range inputs, skip if value equals the default min/max
          if (name === 'filter.v.price.gte' || name === 'filter.v.price.lte') {
            const priceMin = input.getAttribute('data-price-min');
            const priceMax = input.getAttribute('data-price-max');

            // Skip if min value equals default min or max value equals default max
            if ((name === 'filter.v.price.gte' && value == priceMin) ||
                (name === 'filter.v.price.lte' && value == priceMax)) {
              return;
            }
          }

          // Skip empty values for text inputs
          if (!value || !value.trim()) {
            return;
          }
        } else if (input.tagName === 'SELECT') {
          if (!value || !value.trim()) {
            return;
          }
          // Skip sort_by if it's the default value
          if (name === 'sort_by') {
            const defaultSort = input.getAttribute('data-default-sort');
            if (defaultSort && value === defaultSort) {
              return; // Don't add default sort to URL
            }
          }
        } else {
          // Handle other input types
          if (!value) return;
        }

        // Check if this is a size-related filter (custom or native)
        if (name && (name.toLowerCase().includes('size') || name === 'filter.v.option.size' || name.startsWith('filter.p.m.custom.size') || name.includes('Size'))) {
          hasSizeFilter = true;
        }

        // Group parameters by name
        if (!groupedParams[name]) {
          groupedParams[name] = [];
        }
        groupedParams[name].push(value);
      });
    }

    // If size filter is selected, automatically add availability filter for in-stock items
    if (hasSizeFilter && !groupedParams['filter.v.availability']) {
      groupedParams['filter.v.availability'] = ['1']; // 1 = available/in stock
    }

    // Fallback: if sort_by was not captured from form inputs (e.g. nested form issue),
    // look for a sort select directly within the visible tab
    if (!groupedParams['sort_by']) {
      const collectionTabs = document.querySelector('.collection-tabs');
      if (collectionTabs) {
        const visibleTab = collectionTabs.querySelector('.tab-content.visible');
        if (visibleTab) {
          const sortSelect = visibleTab.querySelector('select[id^="CollectionSortBy"]');
          if (sortSelect && sortSelect.value && sortSelect.value.trim()) {
            const defaultSort = sortSelect.getAttribute('data-default-sort');
            if (!defaultSort || sortSelect.value !== defaultSort) {
              groupedParams['sort_by'] = [sortSelect.value];
            }
          }
        }
      }
    }

    // Set parameters - for filter parameters, add each value separately
    for (const [name, values] of Object.entries(groupedParams)) {
      const uniqueValues = [...new Set(values)]; // Remove duplicates
      if (uniqueValues.length > 0) {
        // Check if this is a filter parameter that should have separate entries
        if (name.startsWith('filter.')) {
          // For filter parameters, append each value separately
          uniqueValues.forEach(value => {
            params.append(name, value);
          });
        } else {
          // For non-filter parameters, join with commas as before
          params.set(name, uniqueValues.join(','));
        }
      }
    }

    // Preserve wishlist parameter if collection tab has wishlist_lightbox enabled
    if (FacetFiltersForm.hasWishlistLightbox()) {
      params.set('wishlist', 'true');
    }

    const finalParams = params.toString();

    return finalParams;
  }

  onSubmitForm(searchParams, event) {
    // Prevent duplicate submissions with same params
    if (FacetFiltersForm.isRendering && searchParams === FacetFiltersForm.lastSearchParams) {
      return;
    }

    // Store the search params to detect true duplicates
    FacetFiltersForm.lastSearchParams = searchParams;

    FacetFiltersForm.renderPage(searchParams, event);
  }

  // Debounce rapid checkbox/filter interactions — batches multiple quick clicks into one fetch.
  // Visual feedback in onSubmitHandler fires immediately; only the network request is delayed.
  static scheduleRender(searchParams, event) {
    FacetFiltersForm.pendingRenderParams = searchParams;
    FacetFiltersForm.pendingRenderEvent = event;
    clearTimeout(FacetFiltersForm.renderTimer);
    FacetFiltersForm.renderTimer = setTimeout(() => {
      const params = FacetFiltersForm.pendingRenderParams;
      const evt = FacetFiltersForm.pendingRenderEvent;
      if (FacetFiltersForm.isRendering && params === FacetFiltersForm.lastSearchParams) return;
      FacetFiltersForm.lastSearchParams = params;
      FacetFiltersForm.renderPage(params, evt);
    }, 400);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    // Mark this event as a filter change for scroll handling
    event.shouldScrollToTop = true;

    const currentForm = event.target.closest('form') || this.querySelector('form');

    // Check if this is a checkbox or select element change
    const isCheckbox = event.target && event.target.type === 'checkbox';
    const isSelectElement = event.target && event.target.tagName === 'SELECT';

    // Check if this is a price range input/slider
    const isPriceRangeInput = event.target && (
      event.target.classList.contains('price-range-input') ||
      event.target.classList.contains('price-range-slider')
    );

      // For checkboxes, handle immediately - no setTimeout
      if (isCheckbox) {
        // CRITICAL: Add visual feedback CLASS FIRST, before any other processing
        // This ensures the class is added to the live DOM element before any cloning/replacing happens
        const checkboxLabel = event.target.closest('label');
        const isChecked = event.target.checked;
        const checkboxName = event.target.name;
        const checkboxValue = event.target.value;

        if (checkboxLabel) {
          if (isChecked) {
            checkboxLabel.classList.add('filter-selected');
          } else {
            checkboxLabel.classList.remove('filter-selected');
          }
          // Force immediate style recalculation
          void checkboxLabel.offsetHeight;
        }

        // ALSO update all duplicate checkboxes (unified form may have multiple instances)
        // This ensures visual feedback even if elements are cloned/replaced
        const allMatchingCheckboxes = document.querySelectorAll(`input[type="checkbox"][name="${checkboxName}"][value="${CSS.escape(checkboxValue)}"]`);
        allMatchingCheckboxes.forEach(cb => {
          if (cb !== event.target) {
            const label = cb.closest('label');
            if (label) {
              if (isChecked) {
                label.classList.add('filter-selected');
              } else {
                label.classList.remove('filter-selected');
              }
            }
          }
        });

        // Skip if this checkbox was programmatically changed by single-select logic
        if (event.target.dataset.skipChangeEvent === 'true') {
          return;
        }

        // Prevent duplicate processing - if we're already processing this checkbox, skip
        const checkboxId = event.target.id || event.target.name + event.target.value;
        const now = Date.now();

        if (!FacetFiltersForm.lastCheckboxProcessed) {
          FacetFiltersForm.lastCheckboxProcessed = {};
        }

        // If this checkbox was processed in the last 100ms, skip it
        if (FacetFiltersForm.lastCheckboxProcessed[checkboxId] &&
            now - FacetFiltersForm.lastCheckboxProcessed[checkboxId] < 100) {
          return;
        }

        FacetFiltersForm.lastCheckboxProcessed[checkboxId] = now;

      // CRITICAL FIX: For collection tabs, only process checkboxes from the VISIBLE tab
      const collectionTabs = document.querySelector('.collection-tabs');
      if (collectionTabs) {
        const clickedTabContent = event.target.closest('.tab-content');
        const visibleTab = collectionTabs.querySelector('.tab-content.visible');

        // If the checkbox is NOT in the visible tab, ignore this event completely
        if (clickedTabContent && visibleTab && clickedTabContent !== visibleTab) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }
      }

      // NEW: Handle single-selection for dynamic filter groups
      // Check if this checkbox has the single-select data attribute
      const hasSingleSelect = event.target.hasAttribute('data-single-select');

      // For single-select checkboxes, allow deselection (no filter selected is valid)
      // Only enforce single-selection when checking a box (uncheck others in same group)
      if (hasSingleSelect && isChecked) {
        // Find the filter group this checkbox belongs to
        const facetType = event.target.getAttribute('data-facet-type');
        const facetGroup = event.target.getAttribute('data-facet-group');

        // Query across entire document to catch all instances in unified form
        const allGroupCheckboxes = document.querySelectorAll('input[type="checkbox"][data-single-select="true"]');

        allGroupCheckboxes.forEach(checkbox => {
          if (checkbox !== event.target) {
            // Check if it's the same facet type or group
            const isSameGroup = facetType ?
              checkbox.getAttribute('data-facet-type') === facetType :
              checkbox.getAttribute('data-facet-group') === facetGroup;

            if (isSameGroup && checkbox.checked) {
              // Uncheck WITHOUT triggering change event - set flag first
              checkbox.dataset.skipChangeEvent = 'true';
              checkbox.checked = false;

              // Remove visual selected state immediately
              const uncheckedLabel = checkbox.closest('label');
              if (uncheckedLabel) {
                uncheckedLabel.classList.remove('filter-selected');
              }

              // Remove flag after a short delay
              setTimeout(() => delete checkbox.dataset.skipChangeEvent, 10);
            }
          }
        });
      }

      // Sync checkbox states across all instances (desktop/mobile/tabs)
      if (!hasSingleSelect) {
        // REGULAR CHECKBOX SYNC: For collection tabs, only sync checkboxes within the VISIBLE tab
        // Single unified form - no mobile/desktop duplication
        if (currentForm) {
          // Check if we're in a collection tabs context
          let checkboxScope = currentForm;

          if (collectionTabs) {
            // We're in collection tabs - find the visible tab content
            const visibleTab = event.target.closest('.tab-content');
            if (visibleTab) {
              // Only sync checkboxes within this specific tab
              checkboxScope = visibleTab;
            }
          }

          const allCheckboxes = checkboxScope.querySelectorAll('input[type="checkbox"]');

          allCheckboxes.forEach(checkbox => {
            if (checkbox !== event.target && checkbox.name === checkboxName && checkbox.value === checkboxValue) {
              checkbox.checked = isChecked;
            }
          });
        }

        // Visual feedback class was already added at the start of onSubmitHandler
      }

      // Build search params immediately from the current form only
      const searchParams = this.createSearchParams(currentForm);

      // Debounce: batch rapid multi-checkbox clicks into one request (visual feedback above is already immediate)
      FacetFiltersForm.scheduleRender(searchParams, event);
      return;
    }

    // For all other form inputs, use createSearchParams to build URL from current form state
    if (isSelectElement || isPriceRangeInput) {
      const searchParams = this.createSearchParams(currentForm);
      this.onSubmitForm(searchParams, event);
      return; // Add return to prevent fallthrough
    }

    // Fallback for other input types - collect states after event
    const currentCheckboxStates = {};
    const currentInputStates = {};

    // Collect checkbox states after the event has been processed
    (currentForm || document).querySelectorAll('input[type="checkbox"][name^="filter."]').forEach(checkbox => {
      if (!currentCheckboxStates[checkbox.name]) {
        currentCheckboxStates[checkbox.name] = [];
      }
      if (checkbox.checked) {
        currentCheckboxStates[checkbox.name].push(checkbox.value);
      }
    });

    // Collect price range input states (number inputs)
    (currentForm || document).querySelectorAll('input[type="number"][name^="filter."]').forEach(input => {
      if (input.value && input.value.trim()) {
        const priceMin = input.getAttribute('data-price-min');
        const priceMax = input.getAttribute('data-price-max');

        // Only include if value differs from default min/max
        if ((input.name === 'filter.v.price.gte' && input.value != priceMin) ||
            (input.name === 'filter.v.price.lte' && input.value != priceMax)) {
          currentInputStates[input.name] = input.value;
        }
      }
    });

    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    // Single unified form - no mobile/desktop distinction needed

    // Start with empty parameters - we'll rebuild from current DOM state
    const allParams = new URLSearchParams();

    // Get current sort_by value from the specific form that triggered the event
    let currentSortBy = null;
    const sortSelect = currentForm ? currentForm.querySelector('select[name="sort_by"]') : null;

    if (sortSelect && sortSelect.value && sortSelect.value.trim()) {
      const defaultSort = sortSelect.getAttribute('data-default-sort');
      const isDefault = defaultSort && sortSelect.value === defaultSort;
      if (!isDefault) {
        currentSortBy = sortSelect.value;
      }
    }

    // Add sort_by parameter if found in the current form. If not, try any sort dropdown on the page, then fallback to URL
    if (currentSortBy) {
      allParams.set('sort_by', currentSortBy);
    } else {
      const anySortSelect = document.querySelector('select[name="sort_by"]');
      if (anySortSelect && anySortSelect.value && anySortSelect.value.trim()) {
        const defaultSort = anySortSelect.getAttribute('data-default-sort');
        const isDefault = defaultSort && anySortSelect.value === defaultSort;
        if (!isDefault) {
          allParams.set('sort_by', anySortSelect.value);
        }
      } else {
        // Check if there's an existing sort_by in the URL to preserve (only if not default)
        const urlParams = new URLSearchParams(window.location.search);
        const existingSortBy = urlParams.get('sort_by');
        if (existingSortBy) {
          // Check if this is a default value by checking any visible sort select
          const anySelect = document.querySelector('select[name="sort_by"]');
          const defaultSort = anySelect ? anySelect.getAttribute('data-default-sort') : null;
          if (!defaultSort || existingSortBy !== defaultSort) {
            allParams.set('sort_by', existingSortBy);
          }
        }
      }
    }

    // Add other non-filter parameters from URL (except sort_by which we handle above)
    const currentParams = new URLSearchParams(window.location.search);
    for (const [name, value] of currentParams.entries()) {
      if (name !== 'section_id' && !name.startsWith('filter.') && name !== 'sort_by') {
        allParams.set(name, value);
      }
    }

    // Add filter parameters from the stored checkbox states
    for (const [name, values] of Object.entries(currentCheckboxStates)) {
      values.forEach(value => {
        allParams.append(name, value);
      });
    }

    // Add filter parameters from the stored input states (price range)
    for (const [name, value] of Object.entries(currentInputStates)) {
      allParams.append(name, value);
    }

    // Add availability filter if size filter is selected
    if (currentCheckboxStates['filter.v.option.size'] && currentCheckboxStates['filter.v.option.size'].length > 0) {
      allParams.append('filter.v.availability', '1');
    }

    this.onSubmitForm(allParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    // Mark this event as a filter change for scroll handling
    event.shouldScrollToTop = true;

    FacetFiltersForm.toggleActiveFacets();
    let searchParams =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);

    // Safety: preserve current sort_by when the target URL doesn't specify it
    try {
      const sp = new URLSearchParams(searchParams);
      if (!sp.has('sort_by')) {
        const currentSort = new URLSearchParams(window.location.search).get('sort_by');
        if (currentSort) {
          // Only preserve if it is not the default; attempt to compare against any visible select's data-default-sort
          const anySortSelect = document.querySelector('select[name="sort_by"]');
          const defaultSort = anySortSelect ? anySortSelect.getAttribute('data-default-sort') : null;
          if (!defaultSort || currentSort !== defaultSort) {
            sp.set('sort_by', currentSort);
            searchParams = sp.toString();
          }
        }
      }
    } catch (e) {
      // no-op
    }

    FacetFiltersForm.renderPage(searchParams);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.isRendering = false;
FacetFiltersForm.lastSearchParams = '';
FacetFiltersForm.abortController = null;
FacetFiltersForm.requestId = 0;
FacetFiltersForm.renderTimer = null;
FacetFiltersForm.pendingRenderParams = null;
FacetFiltersForm.pendingRenderEvent = null;
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// Handle "remove all" and "clear all" link clicks
document.addEventListener('DOMContentLoaded', () => {
  const handleClearAllClick = (e) => {
    const link = e.target.closest('a.underlined-link, a.active-facets__button-remove');
    if (!link) return;

    // Check if this is a clear all type link
    const isEmptyCollectionLink = link.closest('.collection--empty');
    const isClearAllButton = link.classList.contains('active-facets__button-remove');
    const isMobileFacetsClear = link.classList.contains('mobile-facets__clear');
    const linkText = link.textContent.toLowerCase().trim();
    const isClearAllText = linkText.includes('remove all') || linkText.includes('clear all') || linkText.includes('clear');

    // Only proceed if this is a clear all type action
    if (!(isEmptyCollectionLink || isClearAllButton || isMobileFacetsClear || isClearAllText)) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    // Mark this event as a filter change for scroll handling
    e.shouldScrollToTop = true;

    // Set a flag to skip restoration after AJAX for collection tabs
    window.skipCollectionTabRestoration = true;

    // Clear collection tab session storage if in collection tabs
    const collectionTabs = document.querySelector('.collection-tabs');
    if (collectionTabs) {
      const activeTabContent = collectionTabs.querySelector('.tab-content.visible');
      if (activeTabContent) {
        const tabIndex = activeTabContent.dataset.tab;
        const collectionHandle = activeTabContent.dataset.collectionHandle;

        // Uncheck all filter checkboxes immediately (before AJAX)
        const allFilterCheckboxes = activeTabContent.querySelectorAll('input[type="checkbox"][name^="filter."]');
        allFilterCheckboxes.forEach(checkbox => {
          if (checkbox.checked) {
            checkbox.checked = false;
          }
        });

        // Try to use the global function if available
        if (typeof window.clearTabFilterState === 'function') {
          window.clearTabFilterState(tabIndex, collectionHandle);
        } else {
          // Fallback: manually clear the session storage
          try {
            const key = `collectionTab_${collectionHandle}_${tabIndex}`;
            sessionStorage.removeItem(key);
          } catch (err) {
            // Silent failure
          }
        }
      }
    }

    // Build URL with only sort parameter preserved (if not default)
    const currentParams = new URLSearchParams(window.location.search);
    const newParams = new URLSearchParams();

    // Preserve sort_by if it exists and is not default
    const sortBy = currentParams.get('sort_by');
    if (sortBy) {
      const sortSelect = document.querySelector('select[name="sort_by"]');
      const defaultSort = sortSelect ? sortSelect.getAttribute('data-default-sort') : 'manual';
      if (sortBy !== defaultSort) {
        newParams.set('sort_by', sortBy);
      }
    }

    // Preserve search query if on search page
    const isSearchPage = window.location.pathname.includes('/search');
    if (isSearchPage) {
      const searchQuery = currentParams.get('q');
      const searchPrefix = currentParams.get('options[prefix]');
      if (searchQuery) {
        newParams.set('q', searchQuery);
      }
      if (searchPrefix) {
        newParams.set('options[prefix]', searchPrefix);
      }
    }

    // If this is a mobile clear, close the drawer after clearing
    if (isMobileFacetsClear) {
      const mobileWrapper = link.closest('.mobile-facets__wrapper');
      if (mobileWrapper) {
        setTimeout(() => {
          const summaryButton = mobileWrapper.querySelector('summary');
          if (summaryButton) {
            summaryButton.click();
          }
        }, 300); // Delay to allow AJAX to complete first
      }
    }

    // Trigger the filter page render without filters
    FacetFiltersForm.renderPage(newParams.toString(), e, true);
  };

  // Use event delegation for dynamically loaded content
  document.body.addEventListener('click', handleClearAllClick);
});

// Remove automatic sort override - let collection use its configured default sort

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    // Mark this event as a filter change for scroll handling
    event.shouldScrollToTop = true;

    // Check if this is the mobile "clear all" button
    const facetLink = this.querySelector('a');
    const isMobileClearAll = facetLink && facetLink.classList.contains('mobile-facets__clear-all-mobile');

    // Check if this is a "clear all" action (either mobile or desktop)
    const isClearAll = isMobileClearAll || (facetLink && facetLink.href && facetLink.href.includes('?') === false);

    // Clear collection tab session storage if this is a clear all action
    if (isClearAll) {
      // Set flag to skip restoration after AJAX
      window.skipCollectionTabRestoration = true;

      const collectionTabs = document.querySelector('.collection-tabs');
      if (collectionTabs) {
        const activeTabContent = collectionTabs.querySelector('.tab-content.visible');
        if (activeTabContent) {
          const tabIndex = activeTabContent.dataset.tab;
          const collectionHandle = activeTabContent.dataset.collectionHandle;

          // Uncheck all filter checkboxes immediately (before AJAX)
          const allFilterCheckboxes = activeTabContent.querySelectorAll('input[type="checkbox"][name^="filter."]');
          allFilterCheckboxes.forEach(checkbox => {
            if (checkbox.checked) {
              checkbox.checked = false;
            }
          });

          // Try to use the global function if available
          if (typeof window.clearTabFilterState === 'function') {
            window.clearTabFilterState(tabIndex, collectionHandle);
          } else {
            // Fallback: manually clear the session storage
            try {
              const key = `collectionTab_${collectionHandle}_${tabIndex}`;
              sessionStorage.removeItem(key);
            } catch (err) {
              // Silent failure
            }
          }
        }
      }
    }

    if (isMobileClearAll) {
      // For mobile clear all, apply the filter reset and close the modal
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

      // Apply the filter reset
      form.onActiveFilterClick(event);

      // Close the mobile facets modal
      const mobileWrapper = this.closest('.mobile-facets__wrapper');
      if (mobileWrapper) {
        const summaryButton = mobileWrapper.querySelector('summary');
        if (summaryButton) {
          summaryButton.click();
        }
      }
    } else {
      // Standard behavior for other facet remove buttons
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    }
  }
}

customElements.define('facet-remove', FacetRemove);
